// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import {
  type GetContentData,
  type GetContentError,
  type GetContentResponse,
  type GetContent20Data,
  type GetContent20Error,
  type GetContent20Response,
  type GetContentItemData,
  type GetContentItemError,
  type GetContentItemResponse,
  type GetContentItemByPathData,
  type GetContentItemByPathError,
  type GetContentItemByPathResponse,
  type GetContentItemByPath20Data,
  type GetContentItemByPath20Error,
  type GetContentItemByPath20Response,
  type GetContentItemByIdData,
  type GetContentItemByIdError,
  type GetContentItemByIdResponse,
  type GetContentItemById20Data,
  type GetContentItemById20Error,
  type GetContentItemById20Response,
  type GetContentItems20Data,
  type GetContentItems20Error,
  type GetContentItems20Response,
  type GetMediaData,
  type GetMediaError,
  type GetMediaResponse,
  type GetMedia20Data,
  type GetMedia20Error,
  type GetMedia20Response,
  type GetMediaItemData,
  type GetMediaItemError,
  type GetMediaItemResponse,
  type GetMediaItemByPathData,
  type GetMediaItemByPathError,
  type GetMediaItemByPathResponse,
  type GetMediaItemByPath20Data,
  type GetMediaItemByPath20Error,
  type GetMediaItemByPath20Response,
  type GetMediaItemByIdData,
  type GetMediaItemByIdError,
  type GetMediaItemByIdResponse,
  type GetMediaItemById20Data,
  type GetMediaItemById20Error,
  type GetMediaItemById20Response,
  type GetMediaItems20Data,
  type GetMediaItems20Error,
  type GetMediaItems20Response,
  GetMediaResponseTransformer,
  GetMedia20ResponseTransformer,
  GetMediaItemResponseTransformer,
  GetMediaItemByPathResponseTransformer,
  GetMediaItemByPath20ResponseTransformer,
  GetMediaItemByIdResponseTransformer,
  GetMediaItemById20ResponseTransformer,
  GetMediaItems20ResponseTransformer,
} from './types.gen';

export const client = createClient(createConfig());

/**
 * @deprecated
 */
export const getContent = <ThrowOnError extends boolean = false>(options?: Options<GetContentData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetContentResponse, GetContentError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/content',
  });
};

export const getContent20 = <ThrowOnError extends boolean = false>(
  options?: Options<GetContent20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContent20Response, GetContent20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/content',
  });
};

/**
 * @deprecated
 */
export const getContentItem = <ThrowOnError extends boolean = false>(
  options?: Options<GetContentItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItemResponse, GetContentItemError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/content/item',
  });
};

/**
 * @deprecated
 */
export const getContentItemByPath = <ThrowOnError extends boolean = false>(
  options: Options<GetContentItemByPathData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItemByPathResponse, GetContentItemByPathError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/content/item/{path}',
  });
};

export const getContentItemByPath20 = <ThrowOnError extends boolean = false>(
  options: Options<GetContentItemByPath20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItemByPath20Response, GetContentItemByPath20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/content/item/{path}',
  });
};

/**
 * @deprecated
 */
export const getContentItemById = <ThrowOnError extends boolean = false>(
  options: Options<GetContentItemByIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItemByIdResponse, GetContentItemByIdError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/content/item/{id}',
  });
};

export const getContentItemById20 = <ThrowOnError extends boolean = false>(
  options: Options<GetContentItemById20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItemById20Response, GetContentItemById20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/content/item/{id}',
  });
};

export const getContentItems20 = <ThrowOnError extends boolean = false>(
  options?: Options<GetContentItems20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetContentItems20Response, GetContentItems20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/content/items',
  });
};

/**
 * @deprecated
 */
export const getMedia = <ThrowOnError extends boolean = false>(options?: Options<GetMediaData, ThrowOnError>) => {
  return (options?.client ?? client).get<GetMediaResponse, GetMediaError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/media',
    responseTransformer: GetMediaResponseTransformer,
  });
};

export const getMedia20 = <ThrowOnError extends boolean = false>(options?: Options<GetMedia20Data, ThrowOnError>) => {
  return (options?.client ?? client).get<GetMedia20Response, GetMedia20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/media',
    responseTransformer: GetMedia20ResponseTransformer,
  });
};

/**
 * @deprecated
 */
export const getMediaItem = <ThrowOnError extends boolean = false>(
  options?: Options<GetMediaItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItemResponse, GetMediaItemError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/media/item',
    responseTransformer: GetMediaItemResponseTransformer,
  });
};

/**
 * @deprecated
 */
export const getMediaItemByPath = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaItemByPathData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItemByPathResponse, GetMediaItemByPathError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/media/item/{path}',
    responseTransformer: GetMediaItemByPathResponseTransformer,
  });
};

export const getMediaItemByPath20 = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaItemByPath20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItemByPath20Response, GetMediaItemByPath20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/media/item/{path}',
    responseTransformer: GetMediaItemByPath20ResponseTransformer,
  });
};

/**
 * @deprecated
 */
export const getMediaItemById = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaItemByIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItemByIdResponse, GetMediaItemByIdError, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v1/media/item/{id}',
    responseTransformer: GetMediaItemByIdResponseTransformer,
  });
};

export const getMediaItemById20 = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaItemById20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItemById20Response, GetMediaItemById20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/media/item/{id}',
    responseTransformer: GetMediaItemById20ResponseTransformer,
  });
};

export const getMediaItems20 = <ThrowOnError extends boolean = false>(
  options?: Options<GetMediaItems20Data, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetMediaItems20Response, GetMediaItems20Error, ThrowOnError>({
    ...options,
    url: '/umbraco/delivery/api/v2/media/items',
    responseTransformer: GetMediaItems20ResponseTransformer,
  });
};
